module.exports = __webpack_public_path__ + "static/5-42d8b3330cbfe4281de88ec0274da50c.jpg";